import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import {
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  Grid,
  Link,
  Typography
} from '@mui/material'
import { spacing } from '@mui/system'
import { styled } from '@mui/material/styles'
import { getLevels, getLevelsByProjectId } from '../../redux/slices/levels'
import useAuth from '../../hooks/useAuth'
import { UserRole } from '../../enums/UserRole'
import LevelTable from '../../components/LevelTable'

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing)
const Divider = styled(MuiDivider)(spacing)

/**
 * @deprecated
 */
export default function Levels() {
  const dispatch = useDispatch()

  const [t] = useTranslation('common')

  const { currentUser } = useAuth()

  useEffect(() => {
    if (currentUser?.activeProject) {
      if (currentUser?.role === UserRole.SUPERADMIN) {
        dispatch(getLevels())
      } else {
        dispatch(getLevelsByProjectId(currentUser?.activeProject.id))
      }
    }
  }, [currentUser])

  return (
    <React.Fragment>
      <Helmet title={t('levels')} />

      <Typography variant="h3" gutterBottom display="inline">
        {t('levels')}
      </Typography>

      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Link component={NavLink} to="/">
          {t('frontpage')}
        </Link>
        <Typography>{t('levels')}</Typography>
      </Breadcrumbs>

      <Divider sx={{ my: 6 }} />

      <Grid container spacing={6}>
        <Grid item xs={12}>
          <LevelTable />
        </Grid>
      </Grid>
    </React.Fragment>
  )
}
